gsap.registerPlugin(SplitText);

var tl = gsap. timeline () ;
splitSubHeading = new SplitText(".anim-text.sub_heading_txt", {type:"chars"}),
tl.from(splitSubHeading.chars, {opacity:0, y:80, delay:0.3, duration:0.5, ease:"back", stagger:0.05})

new SplitText("h2.anim-text", { type: "lines", linesClass: "lineChild" });
new SplitText("h2.anim-text", { type: "lines", linesClass: "lineParent" });

new SplitText(".caption_txt", { type: "lines", linesClass: "lineChild" });
new SplitText(".caption_txt", { type: "lines", linesClass: "lineParent" });

var tl = new TimelineMax({delay:1, yoyo:true});
tl.staggerFrom(".lineChild", 0.75, {y:80}, 0.25);


var tl = gsap.timeline();

var tween = gsap.fromTo(".caption_btns", { y: 50, opacity:0 }, { duration: 1, opacity:1, y: 0, delay:2});
var tween = gsap.fromTo(".custom-reviews-even", { y: 20, opacity:0 }, { duration: 1, opacity:1, y: 0, delay:2.1});
var tween = gsap.fromTo(".sub_heading_r", { y: 20, opacity:0 }, { duration: 1, opacity:1, y: 0, delay:2.2});
tl.add(tween);
